export enum QuestionType {
    text = 'text',
    yesNo = 'yesNo',
    value = 'value'
}
